<div class="card">
  <div class="card-header">
    <h4 class="card-title" id="basic-layout-form">{{ 'auditLogs.title' | translate }}</h4>
    <p class="mb-0">{{ 'auditLogs.text' | translate }}</p>
    <br>
    <input type='text' (keydown.enter)="onKeydown($event)" class="form-control filter-input" [(ngModel)]="newValue"
           placeholder="{{'auditLogs.filterByNewValuePlaceHolder' | translate}}"/>
    <button class="btn btn-raised btn-primary" (click)="searchFilter(newValue)">{{ 'buttons.searchText' | translate }}
    </button>
    <div class="clear-float-left"></div>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th>{{ 'auditLogs.actionFieldTitle' | translate }}</th>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
        </tr>
        </thead>
        <tbody>
        <ng-container
          *ngFor="let auditLog of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <tr>
            <td>
              <a (click)="showDetails(auditLog)" [attr.aria-expanded]="!auditLog.IsCollapsed"
                 [ngbCollapse]="!auditLog.IsCollapsed">
                <i class="ft-plus-square font-medium-3 primary"></i>
              </a>
              <a (click)="showDetails(auditLog)" class="" [ngbCollapse]="auditLog.IsCollapsed">
                <i class="ft-minus-square font-medium-3 warning"></i>
              </a>
            </td>
            <td>{{ auditLog.AuditLogId }}</td>
            <td>{{ auditLog.EventDateUTC | date:'d-M-y HH:mm:ss' }}</td>
            <td>{{ auditLog.UserName || 'SYSTEM' }}</td>
            <td>{{ auditLog.EventType }}</td>
            <td>{{ auditLog.TypeFullName.replace("Nidaros.AIS.Entities.Entities.", "") }}</td>
            <td>{{ auditLog.RecordId }}</td>
          </tr>
          <ng-container *ngIf="auditLog.AuditLogDetails && !auditLog.IsCollapsed">
            <tr *ngFor="let auditLogDetail of auditLog.AuditLogDetails">
              <td colspan="7"></td>
              <td>{{ auditLogDetail.PropertyName }}</td>
              <td>{{ auditLogDetail.OriginalValue || '-' }}</td>
              <td>{{ auditLogDetail.NewValue }}</td>
            </tr>
          </ng-container>
        </ng-container>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
